module.exports = __webpack_public_path__ + "img/auto1111-checkpoint-model-selector.f9cadebd.png";